module.exports = __webpack_public_path__ + "static/media/PolitiqueUtilisationDonnes.b2e7e62c.pdf";